/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import * as yup from 'yup';

/**
 * Here mentioned users feature add user validations
 */

const forbiddenUsernames = ['user', 'users', 'admin', 'admins', 'root', 'preferred'];
//
export const addUserValidation = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email Address is a required field')
    .email('Email address must be valid'),
  username: yup
    .string()
    .trim()
    .required('Username is required')
    .matches(/^[a-zA-Z0-9_.@]*$/, 'Can contain only Alphabets, numbers . and @')
    .max(20, 'Username should not have more than 20 characters')
    .test('is-not-forbidden', (value) => {
      if (value && forbiddenUsernames.includes(value.toLowerCase())) {
        return new yup.ValidationError(`Username cannot be '${value}'`, null, 'username');
      }
      return true;
    }),
  firstName: yup.string().trim().required('First Name is a required field'),
  lastName: yup.string().trim().required('Last Name is a required field'),
  hotels: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string(),
        label: yup.string(),
      })
    )
    .min(1, 'Hotels is a required field'),
  password: yup
    .string()
    .trim()
    .required('Password is a required field')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
      'Password should contain at least 8 characters with One Uppercase, One Lowercase and One Number'
    ),
});
/**
 * Here mentioned users feature update user validations
 */
export const updateUserValidation = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required('Email Address is a required field')
    .email('Email address must be valid'),
  firstName: yup.string().trim().required('First Name is a required field'),
  lastName: yup.string().trim().required('Last Name is a required field'),
  roles: yup.array().min(1, 'Roles is a required field'),
  userHotels: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string(),
        label: yup.string(),
      })
    )
    .min(1, 'User Hotels is a required field'),
});
